// @flow
import * as React from 'react';
import styled from 'styled-components';
import icon_suspended from '../../assets/images/icon_suspended.png';

const  StyledImg = styled.img`
	vertical-align: middle;
	display: inline-block;
	margin-right: 3px;
	margin-bottom: 3px;
`;

export const Suspended = () => (
	<StyledImg src={icon_suspended} alt="Suspended" />
);

export default Suspended;


// WEBPACK FOOTER //
// ./src/components/Icons/Suspended.js